import React from "react";

const ButtonSubmit = ({title, styleButton, isActive, loading, onClick, name, value}) => {
	const disabled = isActive || loading;
	return (
		<div className="button-component" onClick={onClick}>
			<button
				type={"submit"}
				name={name}
				value={value}
				disabled={disabled}
				className={styleButton + (disabled ? " btn-default-inactive" : "")}
			>
				{loading ? (
					<>
						<span className="button-submit-loading-spinner" aria-hidden="true" />
						Enregistrement...
					</>
				) : (
					title
				)}
			</button>
		</div>
	);
};

export default ButtonSubmit;
